import Cookies from "js-cookie";
import http from "utils/http";

// 获取 预警详情页统计数据
export function getDetailStatistics(params) {
  return http({
    url: '/early/warning/summary/statistics',
    method: 'get',
    params,
  });
}


// 预警处理 重新处理回显
export function getRecordBack(params) {
  return http({
    url: '/early/warning/handle/record/back',
    method: 'get',
    params,
  });
}

// 获取预警类型扣分规则
export function getHint(params) {
  params.areaCode = Cookies.get('areaId');
  return http({
    url: '/early/warning/common/hint',
    method: 'get',
    params,
  });
}

// 获取处理状态
export function getHandleStatus() {
  return http({
    url: '/early/warning/common/handlestatus',
    method: 'get',
  });
}

// 获取 处理方式
export function getHandleType(params) {
  return http({
    url: '/early/warning/common/handletype',
    method: 'get',
    params,
  });
}

// 获取 处理部门
export function getHandleDept() {
  return http({
    url: '/early/warning/common/handledept',
    method: 'get',
  });
}

// 获取 获取预警类型 （异常类型）
// 预警类型 0101->食品预警 0102->溯源预警 0103->后厨管理异常预警 0202->AI摄像头预警 0301->监管检查预警 0302->健康证预警 0303->许可证预警 0401->投诉建议预警
export function getType(params) {
  return http({
    url: '/early/warning/common/type',
    method: 'get',
    params,
  });
}

// 预警处理
export function setHandle(data, submitUrl) {
  return http({
    url: submitUrl,
    method: 'post',
    data,
  });
}

// 后厨预警详情列表
export function getChefDetailList(data) {
  return http({
    url: '/early/warning/chef/page',
    method: 'post',
    data,
  });
}

// 食品预警详情分页
export function getFoodDetailList(data) {
  return http({
    url: '/early/warning/food/page',
    method: 'post',
    data,
  });
}

// AI预警详情列表
export function getAIDetailList(data) {
  return http({
    url: '/early/warning/ai/page',
    method: 'post',
    data,
  });
}

// AI预警详情
export function getAIDetail(params) {
  return http({
    url: '/early/warning/ai/detail',
    method: 'get',
    params,
  });
}

// 监管检查预警详情分页
export function getPatrolDetailList(data) {
  return http({
    url: '/early/warning/patrol/page',
    method: 'post',
    data,
  });
}


// 投诉建议详情分页
export function getComplaintDetailList(data) {
  return http({
    url: '/early/warning/complaint/page',
    method: 'post',
    data,
  });
}

// 检测异常详情分页
export function getCheckDetailList(data) {
  return http({
    url: '',
    method: 'post',
    data,
  });
}

// 健康证预警详情
export function getHealthDetailList(data) {
  return http({
    url: '/early/warning/health/page',
    method: 'post',
    data,
  });
}

// 许可证预警详情
export function getLicenseDetailList(data) {
  return http({
    url: '/early/warning/licence/page',
    method: 'post',
    data,
  });
}

// 溯源预警详情
export function getOriginDetailList(data) {
  return http({
    url: '/early/warning/origin/page',
    method: 'post',
    data,
  });
}

// 溯源预警详情
export function getStatisticsList(params) {
  return http({
    url: '/early/warning/summary/assess/statistics',
    method: 'get',
    params,
  });
}

// TogWeb端H5预警中心的预警类型下拉框 (获取菜单)
export function getWarningTypeByEntityId(params) {
  return http({
    url: '/early/warning/common/config/type',
    method: 'get',
    params,
  });
}


 // AI摄像头预警导出
 export function exportData(params) {
  return http({
    method: 'post',
    url: '/early/warning/ai/export',
    data: params
  });
}